import { css } from '@emotion/react';
import styled from '@emotion/styled';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { border, color, compose, layout, position, space } from 'styled-system';

import { forwardValidProp } from '../../utils/style';

const StyledBlock = styled('div', {
  shouldForwardProp: (prop) => forwardValidProp(prop),
})`
  ${css`
    display: block;
  `}
  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `}
  ${compose(border, color, layout, space, position)}
`;

const Block = forwardRef(({ ...props }, ref) => (
  <StyledBlock ref={ref} {...props} />
));

Block.displayName = 'Block';

Block.defaultProps = {
  children: null,
  full: false,
};

Block.propTypes = {
  /**
   * Components to be rendered as children
   */
  children: PropTypes.node,
  /**
   * Block fills the parent component's width
   */
  full: PropTypes.bool,
  /**
   * Implements `styled-system` [border](https://styled-system.com/api/#border) utility
   */
  ...propTypes.border,
  /**
   * Implements `styled-system` [color](https://styled-system.com/api/#color) utility
   */
  ...propTypes.color,
  /**
   * Implements `styled-system` [layout](https://styled-system.com/api/#layout) utility
   */
  ...propTypes.layout,
  /**
   * Implements `styled-system` [space](https://styled-system.com/api/#space) utility
   */
  ...propTypes.space,
  /**
   * Implements `styled-system` [position](https://styled-system.com/api/#position) utility
   */
  ...propTypes.position,
};

export default Block;
